const SHARED_CUSTOMER_FIELDS = [
  'customer_id',
  'customer_name',
  'company'
];

const ESTIMATE_CUSTOMER_FIELDS = [
  'email',
  'office_phone',
  'mobile_phone',
  'street',
  'city',
  'state',
  'zip',
  'address'
];

const DOCUMENT_FIELDS = [
  'terms',
  'notes',
  'discount',
  'discount_selection',
  'sales_tax_rate',
  'county_sales_tax_rate',
  'county_name',
  'state_abbr',
  'state_name',
  'selected_local_tax_ids'
];

const copyAllowlistedFields = (source, fields) =>
  fields.reduce((copy, field) => {
    if (Object.prototype.hasOwnProperty.call(source, field)) {
      copy[field] = source[field];
    }
    return copy;
  }, {});

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null);

const duplicateLineItem = (item, createId) => {
  const duplicate = {
    id: createId(),
    type: item?.type,
    description: item?.description
  };

  if (item?.type === 'note') {
    return duplicate;
  }

  duplicate.qty = item?.qty;
  duplicate.rate = item?.rate;
  duplicate.taxable = item?.taxable === true;

  if (item?.type === 'parts_custom') {
    duplicate.cost = item?.cost;
    duplicate.markup = item?.markup;
  }

  if (
    (item?.type === 'parts_inventory' || item?.type === 'labor') &&
    Object.prototype.hasOwnProperty.call(item, 'source_id')
  ) {
    duplicate.source_id = item.source_id;
  }

  return duplicate;
};

export const createDocumentDuplicateDraft = ({
  documentType,
  sourceDocument,
  freshDocument,
  createId
}) => {
  if (documentType !== 'invoice' && documentType !== 'estimate') {
    throw new TypeError('documentType must be invoice or estimate');
  }

  if (!sourceDocument || typeof sourceDocument !== 'object') {
    throw new TypeError('sourceDocument is required');
  }

  if (!freshDocument || typeof freshDocument !== 'object') {
    throw new TypeError('freshDocument is required');
  }

  if (typeof createId !== 'function') {
    throw new TypeError('createId must be a function');
  }

  const sourceItems = Array.isArray(sourceDocument.items)
    ? sourceDocument.items
    : [];

  const documentFields = copyAllowlistedFields(sourceDocument, DOCUMENT_FIELDS);
  if (Array.isArray(documentFields.selected_local_tax_ids)) {
    documentFields.selected_local_tax_ids = [...documentFields.selected_local_tax_ids];
  }

  const customerFields =
    documentType === 'estimate'
      ? copyAllowlistedFields(sourceDocument, ESTIMATE_CUSTOMER_FIELDS)
      : {
          email: '',
          office_phone: '',
          mobile_phone: '',
          address: '',
          customer_email: firstDefined(
            sourceDocument.customer_email,
            sourceDocument.email,
            ''
          ),
          customer_phone: firstDefined(
            sourceDocument.customer_phone,
            sourceDocument.mobile_phone,
            sourceDocument.office_phone,
            ''
          ),
          customer_address: firstDefined(
            sourceDocument.customer_address,
            sourceDocument.address,
            ''
          )
        };

  return {
    ...freshDocument,
    ...copyAllowlistedFields(sourceDocument, SHARED_CUSTOMER_FIELDS),
    ...customerFields,
    ...documentFields,
    items: sourceItems.map((item) => duplicateLineItem(item, createId))
  };
};
